/**
 * AdminLogin - Redirect to Cognito Hosted UI
 * 
 * No custom login form - just redirect to Cognito's hosted login page
 */

import { useEffect } from 'react';
import { signInWithRedirect, signOut } from 'aws-amplify/auth';
import './AdminLogin.css';

export const AdminLogin = () => {
  useEffect(() => {
    const initiateLogin = async () => {
      try {
        // Clear any stale OAuth state from previous sessions
        // This prevents "InvalidOriginException" when the stored origin doesn't match
        const oauthStateKey = 'amplify-redirect-signIn';
        sessionStorage.removeItem(oauthStateKey);
        localStorage.removeItem(oauthStateKey);
        
        // Also clear any cached Cognito auth state that might be stale
        const cognitoKeys = Object.keys(localStorage).filter(key => 
          key.includes('CognitoIdentityServiceProvider') || 
          key.includes('amplify')
        );
        
        // Only clear if there's no valid session
        try {
          // Attempt to clear stale state without signing out completely
          cognitoKeys.forEach(key => {
            if (key.includes('oauth') || key.includes('redirect')) {
              localStorage.removeItem(key);
            }
          });
        } catch (e) {
          // Ignore errors during cleanup
        }
        
        // Redirect to Cognito Hosted UI
        await signInWithRedirect();
      } catch (err) {
        console.error('[AdminLogin] Redirect failed:', err);
        
        // If redirect fails, try clearing all auth state and retry
        if (err.name === 'InvalidOriginException') {
          console.log('[AdminLogin] Clearing auth state and retrying...');
          try {
            await signOut();
            // Clear all Cognito keys
            Object.keys(localStorage)
              .filter(key => key.includes('CognitoIdentityServiceProvider') || key.includes('amplify'))
              .forEach(key => localStorage.removeItem(key));
            
            // Retry sign in
            await signInWithRedirect();
          } catch (retryErr) {
            console.error('[AdminLogin] Retry failed:', retryErr);
          }
        }
      }
    };

    initiateLogin();
  }, []);

  return (
    <div className="admin-login">
      <div className="admin-login__container">
        <div className="admin-login__loading">
          <div className="admin-spinner"></div>
          <p>Redirecting to login...</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
